import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { MyLogo } from '../components/MyLogo'
import SocialIcons from '../components/SocialIcons'
import Lottie from 'react-lottie'
import cubeLottie from '../assets/lottie-json/lighttheme-cube-lottie.json'
import { motion } from 'framer-motion'
import Popup from '../components/Popup'
import { TabletSize } from '../responsive/TabletSize'
import { MobileSize } from '../responsive/MobileSize'

const Wrapper = styled.div`
    background-color: ${props => props.theme.body};
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    position: absolute;
`;

const Container = styled.div``;

const Blog = styled(NavLink)`
    position: absolute;
    transform: translate(0%, -50%) rotate(90deg); 
    top: 50%;
    right: 0px;
    text-decoration: none;
    z-index: 1;
    ${TabletSize({ top: "60%" })};
`;

const Work = styled(NavLink)`
    position: absolute;
    transform: translate(0%, -50%) rotate(-90deg); 
    top: 50%;
    left: 0px;
    text-decoration: none;
    z-index: 1;
    ${TabletSize({ top: "60%" })};
`;

const BottomBar = styled.div`
    position: absolute;
    bottom: 20px;
    right: 100px;
    left: 100px;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${TabletSize({ bottom: "10px", left: "0px", right: "0px", padding: "0px 20px" })};
    ${MobileSize({ bottom: "10px" })};
`;

const About = styled(NavLink)`
    text-decoration: none;
`;

const MySkill = styled(About)``;

const Text = styled.p`
    font-size: 20px;
    font-weight: bold;
    color: ${props => props.click ? props.theme.body : props.theme.text};
    &:hover{
        transform: scale(1.3);
        transition: 0.25s;
    }
    &:not(:hover){
        transition: 0.25s;
    }
    @media only screen and (max-width: 768px){
       color: ${props => props.theme.text};
    }
    ${MobileSize({ fontSize: "15px" })};
`;

const MainText = styled(Text)``

const CenterIcon = styled.div`
    position: absolute;
    top: ${props => props.click ? null : "50%"};
    left: ${props => props.click ? null : "50%"};
    bottom: ${props => props.click ? "40px" : null};
    right: ${props => props.click ? "20px" : null};
    transform: ${props => props.click ? null : "translate(-50%, -50%)"};
    transition: 0.25s;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    z-index: 3;
    ${TabletSize({ fontSize: "15px", right: `${props => props.click ? "20px" : null}` })};
`;

const DarkDiv = styled.div`
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 50%;
    transform: translateX(${props => props.click ? "0%" : "-100%"});
    background-color: ${props => props.theme === "dark" ? props.theme.body : props.theme.text};
    transition: 0.5s;
    ${TabletSize({ top: "0px", left: "0px", right: "0px", bottom: "50%" })};
`;

export const MainPage = (props) => {

    const defaultOptions = {
        loop: true,
        autoplay: true, 
        animationData: cubeLottie,
    };

    const [isClick, setIsClick] = useState(false);
    const [isTablet, setIsTablet] = useState(false);

    const handleCubeBox = () => {
        if(window.innerWidth <= 768){
            setIsTablet(true);
        }else{
            setIsTablet(false);
        }
    };

    useEffect(() => {
        handleCubeBox()
        window.addEventListener("resize",handleCubeBox);
        window.addEventListener('load',handleCubeBox);
    });

    const lottieIconSize = isClick ? ( isTablet ? 90 : 180) : ( isTablet ? 200 : 350);

  return (
    <Wrapper>
        <Container>
            <MyLogo click={isClick}/>
            <SocialIcons click={isClick} theme={props.theme.isLight ? "light" : "dark"}/>
            <CenterIcon click={isClick} onClick={() => setIsClick(!isClick)}>
                <motion.div>
                    <Lottie
                        options={defaultOptions} 
                        height={lottieIconSize} 
                        width={lottieIconSize}
                    />
                </motion.div>
                { !isClick && <MainText>CLICK HERE...</MainText> }
            </CenterIcon>
            <Blog to="/blog">
                <Text>My Blog</Text>
            </Blog>
            <Work to="/work">
                <Text click={isClick}>My Work</Text>
            </Work>
            <BottomBar>
                <About to="/about">
                    <Text click={isClick}>About Me</Text>
                </About>
                <MySkill to="/myskill">
                    <Text>My Skills</Text>
                </MySkill>
            </BottomBar>
            <DarkDiv click={isClick}/>
            {isClick && <Popup/>}
        </Container>
    </Wrapper>
  )
}

